<template>
  <div id="app">
    <top></top>

    <div class="router-main">
      <router-view/>
    </div>
    <foot></foot>
  </div>
</template>

<script>
import top from "@/components/common/top";
import foot from "@/components/common/foot";
export default {
  name: "App",
  components: {
    top,
    foot
  },
  created() {
    // document.body.removeChild(document.getElementById('loadingpage'));
    $("#loadingpage").hide();
  },
};
</script>

<style lang="less">
#app {
  font-family: "Microsoft YaHei", "微软雅黑", "Helvetica Neue", Helvetica,
    "PingFang SC", "Hiragino Sans GB", Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.share-title {
  font-size: 0.24rem;
  color: #000000;
  span {
    margin-right: 0.2rem;
    font-size: 0.18rem;
    border-bottom: 1px solid #000000;
  }
}

.router-main {
  min-height: 80vh;
}
</style>



// WEBPACK FOOTER //
// src/App.vue